import React from 'react'
import { css } from 'styled-components'
import Star from '../../assets/images/icons/star.svg'
import Tickertape from '../../assets/images/icons/tickertape.svg'
import AlexPlugaruPhoto from '../../assets/images/quotes/alex-240.png'
import CarstenNeuendorfPhoto from '../../assets/images/quotes/carsten-240.png'
import ChristianPhoto from '../../assets/images/quotes/christian-helvin.png'
import DavePhoto from '../../assets/images/quotes/dave.png'
import JosepJaumeReyPhoto from '../../assets/images/quotes/josep.png'
import PauPhoto from '../../assets/images/quotes/pau.png'
import RolandPhoto from '../../assets/images/quotes/roland.png'
import SvyatPhoto from '../../assets/images/quotes/svyat.png'
import TiinaRomuPhoto from '../../assets/images/quotes/tiina-240.png'
import UnknownPhoto from '../../assets/images/quotes/unknown.png'
import VigneshPhoto from '../../assets/images/quotes/vignesh.png'
import MatteoPhoto from '../../assets/images/story/choco/matteo.png'
import TimPhoto from '../../assets/images/story/factoryfix/tim.png'
import AdamPhoto from '../../assets/images/story/hostaway/adam.png'
import WalterPhoto from '../../assets/images/story/miro/walter.png'
import GeroPhoto from '../../assets/images/story/learnship/gero.png'
import MartinPhoto from '../../assets/images/story/pleo/martin.png'
import TatianaPhoto from '../../assets/images/story/prima/tatiana.png'
import DanPhoto from '../../assets/images/story/skutopia/dan.png'
import LucaPhoto from '../../assets/images/story/truelayer/luca-martinetti.png'
import MaryannaPhoto from '../../assets/images/story/truelayer/maryanna-rayko.png'
import SilviaPhoto from '../../assets/images/story/truelayer/silvia-di-nardo.png'
import LucaRPhoto from '../../assets/images/quotes/luca-rossi.png'
import FredPhoto from '../../assets/images/story/smartly/fred.png'
import CristinaTamaraPhoto from '../../assets/images/quotes/cristina-tamara.png'
import MartinOPhoto from '../../assets/images/story/cdq/martinO.png'
import EganPhoto from '../../assets/images/story/engine/egan.png'
import ThomasPhoto from '../../assets/images/story/superhuman/thomas.png'
import { responsiveScale } from '../../styles/helpers'
import Block from '../primitives/Block'
import Box from '../primitives/Box'
import Row from '../primitives/Row'
import Stack from '../primitives/Stack'
import Button from '../system/Button'
import { BlockPaddingProps } from './types'

export type Quote = {
  quote: string
  name: string
  title: string
  photo: string
}

export const quotes = {
  alex: {
    name: 'Alex Plugaru',
    title: 'Co-Founder & CTO at Gorgias',
    quote:
      'With Swarmia, we’re able to highlight problem areas, set target levels, and drive continuous improvement.',
    photo: AlexPlugaruPhoto,
  },
  alex2: {
    name: 'Alex Plugaru',
    title: 'Co-Founder & CTO at Gorgias',
    quote:
      'We use Swarmia to validate our hypotheses with data and drill down to see what’s slowing us down.',
    photo: AlexPlugaruPhoto,
  },
  alex3: {
    name: 'Alex Plugaru',
    title: 'Co-Founder & CTO at Gorgias',
    quote:
      "We used Swarmia's insights to validate our hypotheses with data and drill down into what is slowing down our delivery. This helped us see what to improve and how.",
    photo: AlexPlugaruPhoto,
  },
  alex4: {
    name: 'Alex Plugaru',
    title: 'Co-Founder & CTO at Gorgias',
    quote:
      "With Swarmia, we’ve been able to highlight problem areas, set target levels, and drive continuous improvement. In two months, we’ve decreased our teams' cycle time by 40%.",
    photo: AlexPlugaruPhoto,
  },
  alex5: {
    name: 'Alex Plugaru',
    title: 'Co-Founder & CTO at Gorgias',
    quote:
      'Swarmia responds to the entire engineering organization’s needs. As a leader, I get a global, data-driven overview of what’s going on in my organization.',
    photo: AlexPlugaruPhoto,
  },
  alexSlack: {
    name: 'Alex Plugaru',
    title: 'Co-Founder & CTO at Gorgias',
    quote:
      'The Slack notifications are excellent — way better than the GitHub ones. I was very surprised at how fast our engineers actually adopted Swarmia in their daily routine, and I’m sure the notifications played their part in that.',
    photo: AlexPlugaruPhoto,
  },
  alexDora: {
    name: 'Alex Plugaru',
    title: 'Co-Founder & CTO at Gorgias',
    quote:
      'Having easy access to industry standard metrics like DORA helps us have informed discussions with other departments. Engineering is typically one of the most expensive resources, and DORA metrics help us prove that we are still shipping fast without introducing too many new bugs to the system.',
    photo: AlexPlugaruPhoto,
  },
  alexDevs: {
    name: 'Alex Plugaru',
    title: 'Co-Founder & CTO at Gorgias',
    quote:
      '80-90% of our software engineers use Swarmia daily. They get better statistics, better notifications, and a better understanding of the things they can improve on a day-to-day basis.',
    photo: AlexPlugaruPhoto,
  },
  alexSurveys: {
    name: 'Alex Plugaru',
    title: 'Co-Founder & CTO at Gorgias',
    quote:
      'What I like about running developer experience surveys in Swarmia is that it comes with a set of solid survey questions. After the survey has ended, we can see the qualitative and quantitative data in one place, which you don’t really get in any other tool.',
    photo: AlexPlugaruPhoto,
  },
  alexCost: {
    name: 'Alex Plugaru',
    title: 'Co-Founder & CTO at Gorgias',
    quote:
      'Manually mapping engineering work into capitalizable initiatives used to take us hundreds of hours. Swarmia automates that so my team can focus on doing the work rather than reporting on it.',
    photo: AlexPlugaruPhoto,
  },
  cristinatamara: {
    name: 'Cristina-Tamara Grigorie',
    title: 'Product Director & Operational Advisor at Verdane',
    quote:
      'We recommend Swarmia to engineering organizations in our portfolio, because it delivers the visibility and workflows that growth teams need to scale efficiently.',
    photo: CristinaTamaraPhoto,
  },
  tiina: {
    name: 'Tiina Romu',
    title: 'Software Team Lead at Huuva',
    quote:
      'Swarmia gives our engineers much-needed visibility into their own work and its status.',
    photo: TiinaRomuPhoto,
  },
  carsten: {
    name: 'Carsten Neuendorf',
    title: 'Engineering Director at Productsup',
    quote:
      'Swarmia helps us visualize hidden engineering work. This information allows us to recognize when we need to hire additional people, reduce someone’s workload, or split a team to improve their focus.',
    photo: CarstenNeuendorfPhoto,
  },
  carsten2: {
    name: 'Carsten Neuendorf',
    title: 'Engineering Director at Productsup',
    quote:
      'Our teams set their own working agreements based on what’s relevant and achievable for them. Swarmia reminds each of them if they’re about to slip, which takes the pressure off the team leads.',
    photo: CarstenNeuendorfPhoto,
  },
  josep: {
    name: 'Josep Jaume Rey',
    title: 'Senior Engineering Director at Factorial',
    quote:
      'Swarmia’s GitHub-to-Slack notifications are way better than in any other tool. It’s one of the reasons our engineers really love the product.',
    photo: JosepJaumeReyPhoto,
  },
  josep2: {
    name: 'Josep Jaume Rey',
    title: 'Senior Engineering Director at Factorial',
    quote:
      'Many people at Factorial, including me, get a lot of value out of Swarmia. It’s also been great to see how quickly Swarmia has been shipping new features and improvements over the past year.',
    photo: JosepJaumeReyPhoto,
  },
  svyat: {
    name: 'Svyat Sobol',
    title: 'Lead Engineer at Wolt (part of DoorDash)',
    quote:
      'Swarmia’s Slack notifications make it easy to keep track of open pull requests across all our repos. They help me quickly find the conversations that need my input.',
    photo: SvyatPhoto,
  },
  pau: {
    name: 'Pau Revilla',
    title: 'CTO at Factorial',
    quote:
      'Swarmia gives us quantitative information about how our teams are doing, but without adding any friction.',
    photo: PauPhoto,
  },
  vignesh: {
    name: 'Vignesh Rathika',
    title: 'Senior Technical Program Manager at Choco',
    quote:
      'The goal of the platform team is to provide teams with the tools and insights they need to make sure they can solve all their problems independently. Swarmia helps us give teams more autonomy.',
    photo: VigneshPhoto,
  },
  vignesh2: {
    name: 'Vignesh Rathika',
    title: 'Senior Technical Program Manager at Choco',
    quote:
      'Haystack is a reporting platform but it doesn’t give us the micro feedback loops Swarmia does. We tried to operationalize the insights from Haystack but we quickly realized that we could automate some of that with Swarmia and take a lot of the work off our EMs’ plates.',
    photo: VigneshPhoto,
  },
  christian: {
    name: 'Christian Helvin',
    title: 'Engineering Director at Tithely',
    quote:
      'Swarmia has removed many of the manual reports and places we’d need to pull data from previously.',
    photo: ChristianPhoto,
  },
  christian2: {
    name: 'Christian Helvin',
    title: 'Director of Engineering, Tithe.ly',
    quote:
      'Swarmia has transformed the way our engineering teams work. It allows us to celebrate more milestones as a team and has opened the door to many good conversations regarding productivity and tech debt.',
    photo: ChristianPhoto,
  },
  christian3: {
    name: 'Christian Helvin',
    title: 'Director of Engineering, Tithe.ly',
    quote:
      'Swarmia allows engineers to see how well they perform, encourages better code reviews, and has opened the doors for our technical leads and directors to have positive conversations with direct reports through the use of this data.',
    photo: ChristianPhoto,
  },
  roland: {
    name: 'Roland Fiala',
    title: 'SVP of Engineering, Productsup',
    quote:
      "Swarmia gives us the perfect overview of engineering productivity. I can quickly see how we're doing in terms of cycle time and pull requests, which helps me report back to the business.",
    photo: RolandPhoto,
  },
  matteo: {
    name: 'Matteo Pescarin',
    title: 'Engineering Manager, Choco',
    quote:
      'Swarmia encourages us to have conversations that dramatically increase the alignment between the engineering and product organizations.',
    photo: MatteoPhoto,
  },
  tim: {
    name: 'Tim Nott',
    title: 'CTO, FactoryFix',
    quote:
      'Swarmia instantly gave us a baseline, and we could see historical information on where we were in terms of key metrics.',
    photo: TimPhoto,
  },
  tim2: {
    name: 'Tim Nott',
    title: 'CTO, FactoryFix',
    quote:
      'Swarmia allows us to see in real time when things are starting to slip. Instead of having to wait until a missed deadline, I can proactively communicate about changes in our timeline.',
    photo: TimPhoto,
  },
  tatiana: {
    name: 'Tatiana Pipino',
    title: 'Technical Program Manager',
    quote:
      'Since we started using Swarmia, we’ve seen huge improvements in our ways of working and all our engineering metrics.',
    photo: TatianaPhoto,
  },
  silvia: {
    name: 'Silvia Di Nardo',
    title: 'Head of Product Engineering Operations, TrueLayer',
    quote:
      'What I really like about Swarmia is that everyone in the product engineering organization uses it in different ways. They all get value out of it, but that value changes based on their role.',
    photo: SilviaPhoto,
  },
  maryanna: {
    name: 'Maryanna Rayko',
    title: 'VP of Engineering, TrueLayer',
    quote:
      'I immediately liked what I saw. Swarmia aligns with our way of thinking about the importance of empowering teams and checks all the boxes I have for a tool like this.',
    photo: MaryannaPhoto,
  },
  martin: {
    name: 'Martin Jagusch',
    title: 'Product Manager, Platform at Pleo',
    quote:
      'In six months, we learned that while developing these solutions in-house is possible, it’s also extremely time-consuming. Swarmia gives us a shortcut into the visibility our teams need to improve their workflows.',
    photo: MartinPhoto,
  },
  martin2: {
    name: 'Martin Jagusch',
    title: 'Product Manager, Platform at Pleo',
    quote:
      'Rather than basing conversations on a gut feeling, I can now walk up to a team and say ‘I can see your number of incidents is going up, why is that?’ Swarmia is the starting point to many of the important discussions we have in the engineering and product teams.',
    photo: MartinPhoto,
  },
  dan: {
    name: 'Dan Gaskin',
    title: 'Engineering Manager, SKUTOPIA',
    quote:
      'We’re using Swarmia to improve anything and everything we can within our software development lifecycle. The end-to-end visibility means that we’re not limited in what we can improve.',
    photo: DanPhoto,
  },
  danWA: {
    name: 'Dan Gaskin',
    title: 'Engineering Manager, SKUTOPIA',
    quote:
      'Since adopting the working agreement to limit the number of open pull requests, the team hasn’t gone over the limit once. They’re now able to focus on finishing the work they’ve started, rather than trying to multitask.',
    photo: DanPhoto,
  },
  dave: {
    name: 'Dave Cumberland',
    title: 'CTO, Axios HQ',
    quote:
      'Swarmia has provided us with a clear understanding of where our teams are excelling and where they could use additional support. The combination of quantitative developer insights with periodic qualitative feedback is powerful.',
    photo: DavePhoto,
  },
  dave2: {
    name: 'Dave Cumberland',
    title: 'CTO, Axios HQ',
    quote:
      'Swarmia allows us to pinpoint specific areas for improvement and celebrate our successes. It has become an invaluable asset in enhancing our team’s productivity and satisfaction.',
    photo: DavePhoto,
  },
  dave3: {
    name: 'Dave Cumberland',
    title: 'CTO, Axios HQ',
    quote:
      'The combination of quantitative developer insights with periodic qualitative feedback from developer surveys is powerful. Swarmia allows us to pinpoint specific areas for improvement and celebrate our successes.',
    photo: DavePhoto,
  },
  adam: {
    name: 'Adam Kupcewicz',
    title: 'Director of Engineering, Hostaway',
    quote:
      'With visibility into the right metrics in Swarmia, we were able to set the right ways of working, which significantly improved our lead time.',
    photo: AdamPhoto,
  },
  unknown: {
    name: 'Verified User',
    title: 'Computer Software',
    quote:
      'One of the standout features of Swarmia is its ability to present complex data in a user-friendly format. This has allowed us to easily track progress, identify bottlenecks, and make data-driven decisions.',
    photo: UnknownPhoto,
  },
  luca: {
    name: 'Luca Martinetti',
    title: 'CTO at TrueLayer',
    quote:
      'Like many other tech companies, we now operate with more constraints. We need to make engineering really count and choose what we invest in more carefully. Swarmia gives us visibility into where teams are spending their time and whether they’re struggling somehow.',
    photo: LucaPhoto,
  },
  walter: {
    name: 'Walter de Bruijn',
    title: 'Head of Engineering Productivity at Miro',
    quote:
      'Swarmia both feeds and empowers our insights. It allows our engineers to dive deeper into the metrics in a specialized environment, which would make no sense for us to build for ourselves.',
    photo: WalterPhoto,
  },
  walterMetrics: {
    name: 'Walter de Bruijn',
    title: 'Head of Engineering Productivity at Miro',
    quote:
      'Collecting and sanitizing data from engineering tools like GitHub and Jira was a continuous effort for which we had limited capacity. Frequent changes and malfunctions in the data source APIs were consuming our resources.',
    photo: WalterPhoto,
  },
  walterDora: {
    name: 'Walter de Bruijn',
    title: 'Head of Engineering Productivity at Miro',
    quote:
      'We found ourselves building commodity metrics like DORA and SPACE — and facing the complexity that comes with it. Building and maintaining them in-house is a waste of capacity because there are specialized vendors dedicated to delivering them.',
    photo: WalterPhoto,
  },
  walterDrown: {
    name: 'Walter de Bruijn',
    title: 'Head of Engineering Productivity at Miro',
    quote:
      'We recognize that you can also drown in your own data. Bringing in tools that have too many metrics may not bring the progress you want because there’s too much to look at.',
    photo: WalterPhoto,
  },
  walterExport: {
    name: 'Walter de Bruijn',
    title: 'Head of Engineering Productivity at Miro',
    quote:
      'Swarmia allows us to export, reuse, and unify the data with the rest of our metrics. This means our whole engineering organization can look at the same data and ensures we’re all talking about the same things.',
    photo: WalterPhoto,
  },
  walterInvestment: {
    name: 'Walter de Bruijn',
    title: 'Head of Engineering Productivity at Miro',
    quote:
      'We recommend that all teams look into their investment balance. It helps us answer questions like, are we pushing hard enough on new products or improving existing products? Do we see patterns where keeping the lights on work is becoming an excessive capacity requirement to a team?',
    photo: WalterPhoto,
  },
  walterInvestment2: {
    name: 'Walter de Bruijn',
    title: 'Head of Engineering Productivity at Miro',
    quote:
      'Swarmia doesn’t force us to use a specific investment categorization framework. Instead, we can configure it to split the work exactly how we want. It’s an important tool that helps us keep an eye on the ball and understand where we’re spending our capacity.',
    photo: WalterPhoto,
  },
  walterSlack: {
    name: 'Walter de Bruijn',
    title: 'Head of Engineering Productivity at Miro',
    quote:
      'The most loved Swarmia feature for our engineers is the Slack notifications. They’re much more actionable than GitHub’s native ones. They also automatically make our engineers aware if something is off, so they can start putting effort into improving it.',
    photo: WalterPhoto,
  },
  walterQuality: {
    name: 'Walter de Bruijn',
    title: 'Head of Engineering Productivity at Miro',
    quote:
      'The first reaction from our engineers was that ‘this data can’t be right.’ But because Swarmia allows you to drill down into the raw data behind every aggregate, it’s easy to prove that it is, in fact, correct. In a short time, our engineers gained trust in the data by regularly looking at their own data points.',
    photo: WalterPhoto,
  },
  gero: {
    name: 'Gero Keller',
    title: 'CTPO at Learnship',
    quote:
      'I would recommend a tool like Swarmia to virtually any development organization — small or large. It provides tremendous insights that, if leveraged properly, can transform not just output and outcomes but also engineering culture.',
    photo: GeroPhoto,
  },
  geroInitiatives: {
    name: 'Gero Keller',
    title: 'CTPO at Learnship',
    quote:
      'The initiatives view in Swarmia allows us to see how each epic is advancing toward strategic objectives.',
    photo: GeroPhoto,
  },
  geroCulture: {
    name: 'Gero Keller',
    title: 'CTPO at Learnship',
    quote:
      'Swarmia reinforces a culture of continuous improvement and data-driven decision-making. Our teams have started framing discussions around actual metrics — like cycle time and PR review duration — rather than gut feelings. This helps reduce friction and improve accountability.',
    photo: GeroPhoto,
  },
  jellyfish1: {
    name: 'A verified Jellyfish review on G2',
    title: 'Engineering Manager',
    quote:
      'Real-time data would make Jellyfish an even more useful tool. As it stands, we must wait for our data to refresh overnight or during a manually-triggered update.',
    photo: UnknownPhoto,
  },
  jellyfish2: {
    name: 'A verified Jellyfish review on G2',
    title: 'Engineering Manager',
    quote:
      'The onboarding process was far from smooth. It took our team an inordinate amount of time to figure out how to configure Jellyfish to align with our specific needs. The lack of clear and concise documentation exacerbated this problem, leaving us feeling lost and frustrated during the setup phase.',
    photo: UnknownPhoto,
  },
  jellyfish3: {
    name: 'A verified Jellyfish review on G2',
    title: 'Financial Services',
    quote:
      'Jellyfish’s lack of AI-powered narratives, role-specific insights, planning guidance, and at-risk reporting holds it back to being a tool beyond just a data tool. You want a tool that doesn’t just surface metrics — it tells you what to pay attention to and what action to consider. Adding a strategy lens to the data could be super helpful!',
    photo: UnknownPhoto,
  },
  dx1: {
    name: 'A verified DX review on G2',
    title: 'Financial Services',
    quote:
      'DX focuses primarily on qualitative input using a survey approach. It would be really powerful to connect the survey output with a more systematic data approach, where DORA metrics (for instance) are considered and connected with the survey output, to build the big picture.',
    photo: UnknownPhoto,
  },
  dx2: {
    name: 'A verified DX review on G2',
    title: 'Head of Technology Operations',
    quote:
      'Some metrics could benefit from more context or correlation capabilities — for example, being able to drill down from high-level trends to specific root causes more easily.',
    photo: UnknownPhoto,
  },
  dx3: {
    name: 'A verified DX review on G2',
    title: 'Senior Engineering Manager',
    quote:
      'Mostly, the beneficiary stakeholders of DX are middle+ management. Experienced team leads and line EMs won’t take much value for their day-to-day work.',
    photo: UnknownPhoto,
  },
  dx4: {
    name: 'A verified DX review on G2',
    title: 'Financial Services',
    quote:
      'I’d also really like to be able to integrate it more into our other business workflows. Slack and email integration as an example would be awesome at getting valuable insights to the right people.',
    photo: UnknownPhoto,
  },
  linearb1: {
    name: 'A verified LinearB review on G2',
    title: 'Engineering Leader',
    quote:
      'One potential area for growth is actionable insights; introducing contextual guiding insights, as some competitors do, could significantly enhance LinearB’s utility.',
    photo: UnknownPhoto,
  },
  linearb2: {
    name: 'A verified LinearB review on G2',
    title: 'Engineering Leader',
    quote:
      'LinearB’s initial configuration that compared individual performance within teams posed challenges during the tool rollout.',
    photo: UnknownPhoto,
  },
  linearb3: {
    name: 'A verified LinearB review on G2',
    title: 'Engineering Leader',
    quote:
      'While LinearB tries to provide a single pane of glass from the developer level up to the C level, it doesn’t quite achieve this goal yet. I can see it could greatly benefit on the developer education side and on the C level reporting.',
    photo: UnknownPhoto,
  },
  allstacks1: {
    name: 'A  verified Allstacks review on G2',
    title: 'Engineering Manager',
    quote:
      'Data syncing currently occurs once per day. While that is sufficient for keeping track of overall data aggregation, a more up to date sync of data would be much more convenient for ensuring changes are accurate instead of returning a day later to confirm.',
    photo: UnknownPhoto,
  },
  allstacks2: {
    name: 'A  verified Allstacks review on Gartner',
    title: 'Software Developer',
    quote:
      'Creating and setting up the dashboard initially is not easy. It is difficult to create new users in project and teams. Confusion for new user to check data.',
    photo: UnknownPhoto,
  },
  allstacks3: {
    name: 'A  verified Allstacks review on Gartner',
    title: 'Senior Solutions Architect',
    quote:
      'Engineers have to enter data in two platforms, and combining data with this tool and our Jira platform is a challenge.',
    photo: UnknownPhoto,
  },
  faros1: {
    name: 'A  verified Faros AI review on Gartner',
    title: 'Engineering Leader',
    quote:
      'It would be great to simplify the setup of automated alert notifications and subscription options for dashboards (email/slack etc.) to enhance user engagement.',
    photo: UnknownPhoto,
  },
  faros2: {
    name: 'A  verified Faros AI review on Gartner',
    title: 'Director of Cloud Engineering',
    quote:
      'The product has a steep learning curve for non-data analysts, especially when moving beyond built-in dashboards. It can be time-consuming to keep data synced correctly when using non-standard or imperfect data sources (for example, keeping team rosters updated).',
    photo: UnknownPhoto,
  },
  lucaR: {
    name: 'Luca Rossi',
    title: 'Founder of Refactoring',
    quote:
      'The Build book has the rare virtue of exploring engineering effectiveness from a holistic perspective. It brings the kind of approach — team and outcome-based — that I believe we need today to move forward as an industry. I loved it!',
    photo: LucaRPhoto,
  },
  fred: {
    name: 'Frederic Calvez',
    title: 'Director of Product & Engineering Operations at Smartly',
    quote:
      'We’ve built a self-aware engineering culture, where each team can see how they’re doing. What I really like about Swarmia is that it acts as a mirror for the teams. They use it to proactively identify opportunities for improvement without anyone having to tell them what to do.',
    photo: FredPhoto,
  },
  fred2: {
    name: 'Frederic Calvez',
    title: 'Director of Product & Engineering Operations at Smartly',
    quote:
      'Swarmia acts as a mirror for the teams. They use it to proactively identify opportunities for improvement without anyone having to tell them what to do.',
    photo: FredPhoto,
  },
  fredCI: {
    name: 'Frederic Calvez',
    title: 'Director of Product & Engineering Operations at Smartly',
    quote:
      'Swarmia helps keep our build times in check so our CI costs don’t explode.',
    photo: FredPhoto,
  },
  fredInitiatives: {
    name: 'Frederic Calvez',
    title: 'Director of Product & Engineering Operations at Smartly',
    quote:
      'I check the initiatives view on a daily basis, really looking at how the plan is evolving, what the forecast looks like, how it’s projecting, and where the bottlenecks are. For me, it’s a good way to aggregate thousands of tickets in one single view without losing the ability to jump into specific subtasks when I need to.',
    photo: FredPhoto,
  },
  fredInvestment: {
    name: 'Frederic Calvez',
    title: 'Director of Product & Engineering Operations at Smartly',
    quote:
      'Investment balance is something we check monthly. We want to spend 75-80% of our time on roadmap work, and with Swarmia, we know we’re there.',
    photo: FredPhoto,
  },
  fredWA: {
    name: 'Frederic Calvez',
    title: 'Director of Product & Engineering Operations at Smartly',
    quote:
      'The working agreements and Slack notifications are super useful. They give our engineers the nudges they need when they’re juggling different priorities.',
    photo: FredPhoto,
  },
  fredMetrics: {
    name: 'Frederic Calvez',
    title: 'Director of Product & Engineering Operations at Smartly',
    quote:
      'We can aggregate all this data at different levels: teams, groups, functions. Swarmia allows us to break down our data at any moment and at any level, which is something we wouldn’t be able to do if we had to crunch the numbers manually.',
    photo: FredPhoto,
  },
  martinO: {
    name: 'Martin Ofner',
    title: 'Head of Software Development and Operations at CDQ',
    quote:
      'Transparency changed everything. It’s much easier to understand what teams are doing and where they’re stuck. This saves time and builds confidence that people are working on the right things.',
    photo: MartinOPhoto,
  },
  martinOMicro: {
    name: 'Martin Ofner',
    title: 'Head of Software Development and Operations at CDQ',
    quote:
      'With Swarmia, we’re not micromanaging, we’re not checking individual performance, and there’s no blaming people at all — it’s just better for the company and for becoming better at your own work.',
    photo: MartinOPhoto,
  },
  martinOAutonomy: {
    name: 'Martin Ofner',
    title: 'Head of Software Development and Operations at CDQ',
    quote:
      'With Swarmia, teams can challenge themselves without managers dictating priorities. This has enabled more autonomous, self-managing teams than I thought possible.',
    photo: MartinOPhoto,
  },
  martinOCulture: {
    name: 'Martin Ofner',
    title: 'Head of Software Development and Operations at CDQ',
    quote:
      'Swarmia has already changed our engineering culture. The team is now focused on how individuals can contribute to that impact. Swarmia makes this information transparent, which helps everyone make better decisions.',
    photo: MartinOPhoto,
  },
  egan: {
    name: 'Egan Royal',
    title: 'SVP of Engineering at Engine',
    quote:
      'We’re asking a lot of our engineers: tight timelines, rapid scaling, constant delivery pressure. Developer experience surveys help us understand if we’re pushing too hard in certain areas or if there are systemic issues slowing people down that we can actually fix.',
    photo: EganPhoto,
  },
  eganAi: {
    name: 'Egan Royal',
    title: 'SVP of Engineering at Engine',
    quote:
      'I want to track any productivity increases that we might be able to attribute back to AI. I know that’s tricky to do but I see Swarmia as a key component in solving this challenge.',
    photo: EganPhoto,
  },
  egan3: {
    name: 'Egan Royal',
    title: 'SVP of Engineering at Engine',
    quote:
      'What I like about Swarmia is that all you have to do is connect it to your existing tools and then you get a whole bunch of information — without having to change your process or go through hours of consulting to make sure that the labels on the tickets are just right.',
    photo: EganPhoto,
  },
  eganSurveys: {
    name: 'Egan Royal',
    title: 'SVP of Engineering at Engine',
    quote:
      'We’re asking a lot of our engineers: tight timelines, rapid scaling, constant delivery pressure. Developer experience surveys help us understand if we’re pushing too hard in certain areas or if there are systemic issues slowing people down that we can actually fix.',
    photo: EganPhoto,
  },
  eganSprints: {
    name: 'Egan Royal',
    title: 'SVP of Engineering at Engine',
    quote:
      'We need the business to drive the process, not the process to drive the business. Some teams make more sense to be more Kanban style and some teams, depending on where they are in the call stack, can run sprints. It’s whatever works best for that particular problem — and Swarmia supports that.',
    photo: EganPhoto,
  },
  eganMetrics: {
    name: 'Egan Royal',
    title: 'SVP of Engineering at Engine',
    quote:
      'Directors can see who is pushing the most pull requests and how different people are doing over time. I could technically pull these numbers from GitHub, but it’s really nice to go click in Swarmia and just have it right there.',
    photo: EganPhoto,
  },
  thomas: {
    name: 'Thomas Ongeri',
    title: 'Engineering Leader at Superhuman',
    quote:
      'What surprised me most was how quickly the team rallied around the metrics. Once engineers could see where PRs were getting stuck, they started jumping in to help each other without being asked. That’s the kind of culture shift you can’t force — it has to come from shared visibility.',
    photo: ThomasPhoto,
  },
} satisfies Record<string, Quote>

type Props = BlockPaddingProps & {
  person: keyof typeof quotes
  button?: { text: string; href: string }
}

const QuoteBlock = ({
  person,
  button,
  paddingTop = responsiveScale(92),
  paddingBottom = responsiveScale(92),
}: Props) => {
  const { quote, name, title, photo } = quotes[person]

  return (
    <Block
      justifyContent="center"
      display="flex"
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
    >
      <Row
        space={{ xs: 24, md: 48 }}
        maxWidth="mediumBlock"
        flexDirection={{ xs: 'column', md: 'row' }}
        alignItems={{ xs: 'center', md: 'flex-start' }}
        textAlign={{ xs: 'center', md: 'left' }}
      >
        <Box position="relative">
          <Box.img
            loading="lazy"
            src={Tickertape}
            position="absolute"
            top={60}
            left={-32}
          />
          <Box.img
            loading="lazy"
            src={Star}
            position="absolute"
            top={-10}
            left={100}
          />
          <Box.img loading="lazy" width={120} height={120} src={photo} />
        </Box>
        <Stack space={32} paddingLeft={16}>
          <Box
            font="h3"
            color="blue900"
            maxWidth="smallBlock"
            lineHeight="130%"
            css={css`
              &::before {
                content: '“';
                width: 20px;
                margin-left: -20px;
                display: inline-block;
              }
              &::after {
                content: '”';
                width: 20px;
                /* Prevent flowing to second row*/
                margin-right: -20px;
                display: inline-block;
              }
            `}
          >
            {quote}
          </Box>
          <Stack position="relative">
            <Box font="h5">{name}</Box>
            <Box color="black400">{title}</Box>
            {button ? (
              <Button
                position={{ xs: 'static', md: 'absolute' }}
                href={button.href}
                variant="primary"
                size="large"
                css={css({
                  '&:hover .arrow': {
                    left: 2,
                  },
                })}
                right={0}
                borderRadius={9999}
                marginTop={{ xs: 32, md: 0 }}
                arrow
                alignSelf="center"
              >
                {button.text}
              </Button>
            ) : null}
          </Stack>
        </Stack>
      </Row>
    </Block>
  )
}

export default QuoteBlock
